import { RootState } from '../rootReducer';

export const selectPayment = (state: RootState) => state.payment.payment.payment;
export const selectPaymentMethod = (state: RootState) => state.payment.payment.paymentMethod;
